import React from 'react';
import Button from "@mui/material/Button";
import SettingsIcon from "@mui/icons-material/Settings";

const QualityModeButton = ({ enhanced3DQuality, onToggle }) => (
  <Button
    className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
    style={{ backgroundColor: "white" }}
    startIcon={<SettingsIcon />}
    onClick={onToggle}
  >
    {enhanced3DQuality ? "Variant 2" : "Variant 1"}
  </Button>
);

export default QualityModeButton;
